<template>
    <div>
        <h2 class="balance">
            Баланс
            <span class="data-rows-number">
                {{ formatMoney(this.projectBalance / 100, this.region) }}
            </span>
        </h2>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import currency from '../mixins/currency'

export default {
  name: 'BalanceView',

  mixins: [
    currency,
  ],

  methods: {
    fetchBalance () {
      this.$store.dispatch('project/fetchBalance', this.$route.params.id)
    },
  },

  computed: mapGetters({
    region: 'project/region',
    projectBalance: 'project/balance',
  }),

  mounted () {
    this.fetchBalance()
  },
}
</script>

<style scoped>
.balance {
    margin-top: -8px;
    margin-left: 20px;
    font-size: 28px;
    font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/BalanceView.vue